var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.504,
    height: 20,
    viewBox: "0 0 22.504 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-edit",
    "data-name": "Icon awesome-edit",
    d: "M15.73,3.254l3.524,3.524a.382.382,0,0,1,0,.539L10.721,15.85l-3.626.4a.76.76,0,0,1-.84-.84l.4-3.626L15.19,3.254A.382.382,0,0,1,15.73,3.254Zm6.329-.895L20.152.452A1.528,1.528,0,0,0,18,.452L16.613,1.836a.382.382,0,0,0,0,.539L20.137,5.9a.382.382,0,0,0,.539,0l1.383-1.383a1.528,1.528,0,0,0,0-2.157ZM15,13.529v3.977H2.5V5h8.978a.48.48,0,0,0,.332-.137L13.374,3.3a.469.469,0,0,0-.332-.8H1.875A1.876,1.876,0,0,0,0,4.379V18.132a1.876,1.876,0,0,0,1.875,1.875H15.628A1.876,1.876,0,0,0,17.5,18.132V11.966a.47.47,0,0,0-.8-.332L15.14,13.2A.48.48,0,0,0,15,13.529Z",
    transform: "translate(0 -0.007)",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDisabled);
export default __webpack_public_path__ + "static/media/editDisabled.34a6db9611dbffa34c82c776894f70a2.svg";
export { ForwardRef as ReactComponent };